export default "dist/images/block-feature-grid-large-mid.8a1dfe5.png";